import { Button, Flex, HStack, Text } from "@chakra-ui/react";
import { MENUS_ITEMS_ROLE_VALUE_HIGHLIGHTED } from "@raiden/library/constants/menus/items";
import useTranslate from "@raiden/library/hooks/useTranslate";
import { memo } from "react";
import { FormattedMessage } from "react-intl";
import { Href } from "../../../../../../components/Href";
import { getMenuItemAdapterValues } from "../../../../../../helpers/menus/getMenuItemAdapterValues";

export const MenuItem = memo(
  /**
   * @typedef {Object} Props
   * @property {import("@raiden/library/types/Configuration").ConfigurationMenuItem} menuItem
   * @property {() => void} onClickMenu
   */
  /**
   * @param {Props} props
   */
  function MenuItem({ menuItem, onClickMenu }) {
    const translate = useTranslate();
    const { title, href, target } = getMenuItemAdapterValues({
      menuItem,
      translate,
    });

    return (
      <>
        {menuItem.role === MENUS_ITEMS_ROLE_VALUE_HIGHLIGHTED ? (
          <Flex alignItems="center">
            <Href href={href} target={target} flexGrow={1}>
              <Button
                colorScheme="brandPrimary"
                h="42px"
                fontSize="1.25rem"
                fontWeight={400}>
                <FormattedMessage defaultMessage="Nous contacter" />
              </Button>
            </Href>
          </Flex>
        ) : (
          <HStack minH="61px" spacing="0">
            <Href href={href} target={target} flexGrow={1}>
              <HStack
                as={menuItem.children.length > 0 ? "button" : "div"}
                flexGrow={1}
                onClick={onClickMenu}
                alignSelf="stretch">
                <Text variant="text-button" color="brandPrimary.900">
                  {title}
                </Text>
              </HStack>
            </Href>
          </HStack>
        )}
      </>
    );
  },
);
